export class NewGoodsProposalModel {
  public allCoop = false;

  constructor(
    public proposalId = '',
    public classCode = '',
    public goodsName = '',
    public standardName = '',
    public janCode = '',
    public standardSellingPrice = '',
    public special1SellingPrice = '',
    public special2SellingPrice = '',
    public standardCostPrice = '',
    public special1CostPrice = '',
    public special2CostPrice = '',
    public expirationDate = '',
    public bestBeforeDate = '',
    public expandableCoop = {
      ibaraki: false,
      tochigi: false,
      gunma: false,
      chiba: false,
      saitama: false,
      tokyo: false,
      nagano: false,
      niigata: false
    },
  ) {
    this.allCoop = Object.values(this.expandableCoop).every(coop => coop);
  }

  copy() {
    return new NewGoodsProposalModel(
      this.proposalId,
      this.classCode,
      this.goodsName,
      this.standardName,
      this.janCode,
      this.standardSellingPrice,
      this.special1SellingPrice,
      this.special2SellingPrice,
      this.standardCostPrice,
      this.special1CostPrice,
      this.special2CostPrice,
      this.expirationDate,
      this.bestBeforeDate,
      { ...this.expandableCoop },
    );
  }
}